import React, { useEffect } from 'react';
import { useAuth } from '../stores/supabaseAuthStore';

interface AuthInitializerProps {
  children: React.ReactNode;
}

/**
 * AuthInitializer component that handles Supabase Auth initialization
 * Should be placed at the root of the app to ensure auth state is initialized
 */
export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const { initialize, isInitialized } = useAuth();

  useEffect(() => {
    // Initialize auth state and set up listeners
    initialize();
  }, [initialize]);

  // You could show a loading screen here while auth initializes
  if (!isInitialized) {
    return (
      <div className="min-h-screen bg-kind-deep flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-kind-purple mx-auto mb-4"></div>
          <p className="text-kind-text-secondary">Initializing...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
